export default [
  {
    name: 'Development.Managers',
    path: 'managers',
    component: () => import('./components/managers/List'),
  },
  {
    name: 'Development.Managers.Edit',
    path: 'managers/:id?/edit',
    props: true,
    component: () => import('./components/managers/Edit'),
  },
  {
    name: 'Development.Cities',
    path: 'cities',
    component: () => import('./components/cities/List'),
  },
  {
    name: 'Development.Cities.Edit',
    path: 'cities/:id?/edit',
    props: true,
    component: () => import('./components/cities/Edit'),
  },
]
